module.exports = __webpack_public_path__ + "static/media/goBisons.86ebde57.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/goBisons.png
// module id = 42
// module chunks = 0